// src/constants/languages.tsx
import { useTranslation } from "react-i18next";

export interface Language {
  id: number;
  name: string;
  code: string;
}

/** Stable list for routing / i18n checks (do not derive from hooks). */
export const SUPPORTED_LANGUAGE_CODES = ["az", "en", "es", "de"] as const;

export const useLanguages = (): Language[] => {
  const { t } = useTranslation();

  return [
    {
      id: 1,
      name: t("languages.az", "Azerbaijani"),
      code: "az",
    },
    {
      id: 2,
      name: t("languages.en", "English"),
      code: "en",
    },
    {
      id: 3,
      name: t("languages.es", "Spanish"),
      code: "es",
    },
    {
      id: 4,
      name: t("languages.de", "German"),
      code: "de",
    },
  ];
};

export default useLanguages;
